/**
 * Created by piotr@revisual.io on 05/05/2026
 */
import { useCallback } from "react";
import { useHistory } from "react-router-dom";
import Card from "../../../theme/untitled/Card/Card";
import Badge from "../../../theme/untitled/Badge/Badge";
import ProgressMeter from "../../../theme/untitled/ProgressMeter/ProgressMeter";
import styles from "./UsageCard.module.scss";

/**
 * A single tracked-quota card — title, badge or `usage / limit` figure in
 * the header, description, and (when the limit is a real number) a usage
 * bar that grows a "used / upgrade" note once the limit is reached.
 *
 * @param {Object} props
 * @param {string} props.title
 * @param {string} props.description
 * @param {number} props.usage
 * @param {number} props.limit - `-1` means unlimited, no bar is shown
 */
export const UsageCard = ({ title, description, usage, limit }) => {
  const history = useHistory();
  const numericLimit = Number(limit);
  const limitExceeded = numericLimit !== -1 && usage >= numericLimit;
  const limitLabel = numericLimit === -1 ? "∞" : numericLimit;
  const showBar = numericLimit > 0;

  const goToBilling = useCallback(() => history.push("/billing"), [history]);

  return (
    <Card>
      <Card.Header title={title}>
        {limitExceeded ? (
          <Badge color="error">Limit reached</Badge>
        ) : (
          <span className={styles.usageSummary}>
            {usage}{" "}
            <span className={styles.usageSummaryLimit}>/ {limitLabel}</span>
          </span>
        )}
      </Card.Header>
      <Card.Body>
        <p className={styles.description}>{description}</p>
        {showBar && (
          <ProgressMeter
            value={usage}
            max={numericLimit}
            note={limitExceeded ? `${usage} of ${limitLabel} used` : undefined}
            noteVariant="error"
            noteAction={
              limitExceeded
                ? { label: "Upgrade for more →", onClick: goToBilling }
                : undefined
            }
          />
        )}
      </Card.Body>
    </Card>
  );
};

export default UsageCard;
